import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'na-storefront-meta-search-loader',
  templateUrl: './meta-search-loader.component.html',
  styleUrls: ['./meta-search-loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MetaSearchLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
